import React from 'react';

export default (props)=> {
  return (
    <div className="title" dangerouslySetInnerHTML={{__html: props.title}}>
    </div>
  )
}
